import React from "react";
import { Card, Row } from "antd";

import CostumeSelector from "./CostumeSelector";

const CostumeSelect = ({ currentPlayer, userData, setProfile }) => {
    const costumeTypes = [
        {
            name: "head",
            maxCostumeValue: 139,
        },
        {
            name: "face",
            maxCostumeValue: 58,
        },
        {
            name: "body",
            maxCostumeValue: 155,
        },
        {
            name: "kigurumi",
            maxCostumeValue: 153,
        },
        {
            name: "puchi",
            maxCostumeValue: 128,
        },
    ];

    return (
        <Card title="Player Costume">
            <Row gutter={16} style={{ marginBottom: `16px` }}>
                <div
                    style={{
                        display: `flex`,
                        flexWrap: `wrap`,
                        width: `100%`,
                    }}
                >
                    {costumeTypes.map((type, index) => {
                        return (
                            <CostumeSelector
                                key={index}
                                type={type.name}
                                currentPlayer={currentPlayer}
                                userData={userData}
                                setProfile={setProfile}
                                maxCostumeValue={type.maxCostumeValue}
                            />
                        );
                    })}
                </div>
            </Row>
        </Card>
    );
};

export default CostumeSelect;
